
import { useState } from "react";
import {
  createUserWithEmailAndPassword
} from "firebase/auth";

import { ref, set } from "firebase/database";
import { auth, database } from "../services/firebase";
import { useNavigate, Link } from "react-router-dom";

export default function Register() {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirm: "",
    mobile: "",
    gender: "",
    degree: "",
    age: "",
    state: "",
    district: "",
    department: ""
  });

  const change = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirm) return alert("Password mismatch");
    if (form.mobile.length !== 10) return alert("Mobile must be 10 digits");

    try {
      const res = await createUserWithEmailAndPassword(
        auth,
        form.email,
        form.password
      );

      const uid = res.user.uid;

      await set(ref(database, "users/" + uid), {
        uid,
        ...form,
        createdAt: Date.now()
      });

      alert("Registration Successful");
      navigate("/login");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div
      className="premium-auth-wrapper"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(56,189,248,0.10), transparent 24%), radial-gradient(circle at top right, rgba(168,85,247,0.10), transparent 26%), linear-gradient(135deg, #020617, #0f172a, #111827)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px"
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-7">
            <div
              style={{
                borderRadius: "28px",
                padding: "34px 28px",
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.10)",
                backdropFilter: "blur(20px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)"
              }}
            >
              <div className="text-center mb-4">
                <div
                  style={{
                    display: "inline-block",
                    padding: "8px 18px",
                    borderRadius: "999px",
                    background: "rgba(34,197,94,0.12)",
                    border: "1px solid rgba(34,197,94,0.18)",
                    color: "#4ade80",
                    fontWeight: 800,
                    fontSize: "12px",
                    letterSpacing: "1px"
                  }}
                >
                  UPSC STUDENT REGISTRATION
                </div>

                <h2
                  className="fw-bold mt-4 mb-2"
                  style={{
                    color: "#ffffff",
                    fontSize: "2rem"
                  }}
                >
                  Create Your Account
                </h2>

                <p style={{ color: "#94a3b8", marginBottom: 0 }}>
                  Start your disciplined UPSC preparation with premium structure.
                </p>
              </div>

              <form onSubmit={submit}>
                <div className="row">
                  <div className="col-md-6">
                    <input
                      name="name"
                      className="form-control mb-3"
                      placeholder="Full Name"
                      onChange={change}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control mb-3"
                      placeholder="Email Address"
                      onChange={change}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <div className="input-group mb-3">
                      <input
                        type={show ? "text" : "password"}
                        name="password"
                        className="form-control"
                        placeholder="Password"
                        onChange={change}
                        required
                      />

                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShow(!show)}
                      >
                        {show ? "🙈" : "👁"}
                      </button>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <input
                      type="password"
                      name="confirm"
                      className="form-control mb-3"
                      placeholder="Confirm Password"
                      onChange={change}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      name="mobile"
                      className="form-control mb-3"
                      placeholder="Mobile (10 digits)"
                      onChange={change}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <select
                      name="gender"
                      className="form-control mb-3"
                      onChange={change}
                    >
                      <option value="">Select Gender</option>
                      <option>Male</option>
                      <option>Female</option>
                      <option>Transgender</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <select
                      name="degree"
                      className="form-control mb-3"
                      onChange={change}
                    >
                      <option value="">Select Degree</option>
                      <option>UG</option>
                      <option>PG</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <input
                      name="age"
                      className="form-control mb-3"
                      placeholder="Age"
                      onChange={change}
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      name="state"
                      className="form-control mb-3"
                      placeholder="State"
                      onChange={change}
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      name="district"
                      className="form-control mb-3"
                      placeholder="District"
                      onChange={change}
                    />
                  </div>

                  <div className="col-md-6">
                    <select
                      name="department"
                      className="form-control mb-3"
                      onChange={change}
                    >
                      <option value="">Preferred Service</option>
                      <option>IAS</option>
                      <option>IPS</option>
                      <option>IFS</option>
                    </select>
                  </div>
                </div>

                <button className="btn btn-success w-100 py-3 fw-bold rounded-4 mt-2">
                  Create Account
                </button>

                <p className="text-center mt-3 mb-0">
                  Already have account? <Link to="/login">Login</Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}